export default "__VITE_ASSET__Dt$SjYeX__"